export default __webpack_public_path__ + "static/media/emotional-balance-tree.eb52cf4b.svg";